import { useState } from "react";

export default function Tutorial() {

  const [active, setActive] = useState("1");

  return (
    <div className="tutorial">
      <div className="tutorial__title">Kuidas Turgoil töötab?</div>
      <div className="switch">
        <div className={`active-side ${active === "2" ? "right" : ""}`} />

        <button onClick={() => { setActive("1") }}>
          Korralda hange
        </button>

        <button onClick={() => setActive("2")}>
          Automatiseeri ost
        </button>
      </div>

      {active === "1" && (
        <div>
          <div className="diagram-desktop">
            <ul className="diagram-container">
              <li className="dot">
                <div className="tutorial__text-container">
                  <div className="tutorial__text-title">Loo konto</div>
                  <div className="tutorial__text-content">
                    Liitu hankeplatvormiga<br></br> ja loo kasutaja.
                  </div>
                </div>
              </li>
              <li className="dot">
                <div className="tutorial__text-container">
                  <div className="tutorial__text-title">Lisa hange</div>
                  <div className="tutorial__text-content">
                    Lisa hange mõne lihtsa<br></br> sammuga.
                  </div>
                </div>
              </li>
              <li className="dot">
                <div className="tutorial__text-container">
                  <div className="tutorial__text-title">Oota pakkumisi</div>
                  <div className="tutorial__text-content">
                    Peale hanke lisamist on hange<br></br> aktiivne ja pakkujad
                    saavad <br></br>Teile pakkumisi teha.
                  </div>
                </div>
              </li>
              <li className="dot">
                <div className="tutorial__text-container">
                  <div className="tutorial__text-title">Vali võitja</div>
                  <div className="tutorial__text-content">Võitja valimine.</div>
                </div>
              </li>
            </ul>
          </div>
          <div className="diagram-mobile">
            <ul className="diagram-container">
              <li className="dot">
                <div className="tutorial__text-container">
                  <div className="tutorial__text-title">Loo konto</div>
                  <div className="tutorial__text-content">
                    Liitu hankeplatvormiga ja loo kasutaja.
                  </div>
                </div>
              </li>
              <li className="dot">
                <div className="tutorial__text-container">
                  <div className="tutorial__text-title">Lisa hange</div>
                  <div className="tutorial__text-content">
                    Lisa hange mõne lihtsa sammuga.
                  </div>
                </div>
              </li>
              <li className="dot">
                <div className="tutorial__text-container">
                  <div className="tutorial__text-title">Oota pakkumisi</div>
                  <div className="tutorial__text-content">
                    Peale hanke lisamist on hange aktiivne ja pakkujad saavad
                    Teile pakkumisi teha.
                  </div>
                </div>
              </li>
              <li className="dot">
                <div className="tutorial__text-container">
                  <div className="tutorial__text-title">Vali võitja</div>
                  <div className="tutorial__text-content">Võitja valimine.</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

      )}

      {active === "2" && (
        <div>
          <div className="diagram-desktop">
            <ul className="diagram-container">
              <li className="dot">
                <div className="tutorial__text-container">
                  <div className="tutorial__text-title">Broneeri<br /> demo</div>
                  <div className="tutorial__text-content">
                    Saada päring ning <br />  võtame sinuga ühendust, <br /> et leppida   kokku sobiv aeg.
                  </div>
                </div>
              </li>
              <li className="dot">
                <div className="tutorial__text-container">
                  <div className="tutorial__text-title">Liidestame ERP<br /> või mahutid</div>
                  <div className="tutorial__text-content">
                    Ühendame Turgoili sinu <br />olemasoleva süsteemi või <br />mahutite seirelahendusega.
                  </div>
                </div>
              </li>
              <li className="dot">
                <div className="tutorial__text-container">
                  <div className="tutorial__text-title">Turgoil automatiseerib hanked</div>
                  <div className="tutorial__text-content">
                    Hanked käivituvad automaatselt <br /> ning pakkumised kogutakse <br />ühte vaatesse.
                  </div>
                </div>
              </li>
              <li className="dot">
                <div className="tutorial__text-container">
                  <div className="tutorial__text-title">Kütus tellitakse automaatselt</div>
                  <div className="tutorial__text-content">Tellimus edastatakse tarnijale automaatselt vastavalt sinu seadistustele.</div>
                </div>
              </li>
            </ul>
          </div>
          <div className="diagram-mobile" style={{ paddingBottom: '50px' }}>
            <ul className="diagram-container" style={{ height: '560px' }}>
              <li className="dot">
                <div className="tutorial__text-container" style={{ paddingBottom: '30px' }}>
                  <div className="tutorial__text-title" style={{ textAlign: 'left' }}>Broneeri<br />demo</div>
                  <div className="tutorial__text-content">
                    Saada päring ning võtame sinuga ühendust, et leppida kokku sobiv aeg.
                  </div>
                </div>
              </li>
              <li className="dot">
                <div className="tutorial__text-container" style={{ paddingBottom: '30px' }}>
                  <div className="tutorial__text-title" style={{ textAlign: 'left' }}>Liidestame ERP või mahutid</div>
                  <div className="tutorial__text-content">
                    Ühendame Turgoili sinu olemasoleva süsteemi või mahutite seirelahendusega.
                  </div>
                </div>
              </li>
              <li className="dot">
                <div className="tutorial__text-container" style={{ paddingBottom: '30px' }}>
                  <div className="tutorial__text-title" style={{ textAlign: 'left' }}>Turgoil automatiseerib hanked</div>
                  <div className="tutorial__text-content">
                    Hanked käivituvad automaatselt ning pakkumised kogutakse ühte vaatesse.
                  </div>
                </div>
              </li>
              <li className="dot">
                <div className="tutorial__text-container" style={{ paddingBottom: '30px' }}>
                  <div className="tutorial__text-title" style={{ textAlign: 'left' }}>Kütus tellitakse automaatselt</div>
                  <div className="tutorial__text-content" style={{ paddingBottom: '40px' }}>Tellimus edastatakse tarnijale automaatselt vastavalt sinu seadistustele.</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      )}

    </div>
  );
}
